import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'
import { SlHome } from 'react-icons/sl'
import { BsWallet, BsGift } from 'react-icons/bs'
import { FiUser, FiUsers } from 'react-icons/fi'
import { AiOutlineMessage } from 'react-icons/ai'
import { BiMessageSquareDetail } from 'react-icons/bi'
import io from '../Components/socket'
import Socket from "./../Components/socket";

const BottonMenu = ({ w3_close }) => {

    const [open, setOpen] = useState(false)


  useEffect(() => {
      io.on("setProfile", (data) => {
  
        setOpen(data.superUser)
  
      });
  
    }, [Socket])
  
 useEffect(() => {
    const data = localStorage.getItem("udata")
    const userData = (JSON.parse(data))
    setOpen(userData?.superUser)

  }, []);
  return (
    <div className='main_bottom_menus' style={{}}>
      <nav className='bottom_link_main'>
        <NavLink
          exact
          to='/landing'
          className='bottom_link '
          activeClassName='active_link' onClick={w3_close}
        >
          <SlHome className='sidebar_link_icon' />
          <span> Home</span>
        </NavLink>
        {
          open == true ?
        <NavLink
          exact
          to='/wallet'
          className='bottom_link '
          activeClassName='active_link' onClick={w3_close}
        >
          <BsWallet className='sidebar_link_icon' />

          <span> My wallet</span>
        </NavLink> : ""
        }
        <NavLink
          exact
          to='/refer'
          className='bottom_link '
          activeClassName='active_link' onClick={w3_close}
        >
          <FiUsers className='sidebar_link_icon' />

          <span> Refer</span>
        </NavLink>
          {open == true ?
        <NavLink
          exact
          to='/support'
          className='bottom_link '
          activeClassName='active_link' onClick={w3_close}
        >
          <BiMessageSquareDetail className='sidebar_link_icon' />

          <span> Support</span>
        </NavLink> :""}
        <NavLink
          exact
          to='/Profile'
          className='bottom_link '
          activeClassName='active_link' onClick={w3_close}
        >
          <FiUser className='sidebar_link_icon' />

          <span> Profile</span>
        </NavLink>
      </nav>
    </div>
  )
}

export default BottonMenu
